export const MAX_SOCIAL_CONNECTION_ID_LENGTH = 128

export function normalizeSocialConnectionId(value: unknown): string | null {
  if (typeof value !== 'string')
    return null
  const normalized = value.trim()
  return normalized.length > 0
    && normalized.length <= MAX_SOCIAL_CONNECTION_ID_LENGTH
    ? normalized
    : null
}
